import { useIntl } from '@capsicum/common';

export const useNCWGovernanceStakingDappOnlyDrawer = () => {
	const { $t } = useIntl();

	return {
		intlText: {
			continueButtonText: $t('global.button.continue'),
			description1: $t('ncWallet.walletConnect.governanceStakingDappDrawer.description1'),
			description2: $t('ncWallet.walletConnect.governanceStakingDappDrawer.description2'),
			title: $t('ncWallet.walletConnect.governanceStakingDappDrawer.title')
		}
	};
};
